import { useEffect } from 'react';

const SITE_TITLE_SUFFIX = '｜LessonMate';
const DEFAULT_TITLE = 'LessonMate | 教室の運営をもっとスマートに。';

/**
 * ページタイトルを「ページ名｜LessonMate」形式に設定する。
 * アンマウント時にデフォルトタイトルに戻す。
 */
export function usePageTitle(pageName: string) {
  useEffect(() => {
    document.title = `${pageName}${SITE_TITLE_SUFFIX}`;
    return () => {
      document.title = DEFAULT_TITLE;
    };
  }, [pageName]);
}
